import * as angular from "angular";
import { User } from "oidc-client";
import "./beng-logs.less";
import { IBEngLogEncryptionArgs } from "../../typings/board/Admin";

export const BENGLOG_PASSWORD_DIALOG_SERVICE = "bengLogPasswordDialogService";

export class BengLogPasswordDialogService {

    static $inject = ["$q", "$mdDialog"];
    constructor(private $q: ng.IQService, private $mdDialog: ng.material.IDialogService) { }

    showSetPasswordDialog(boardWebUser: User): ng.IPromise<IBEngLogEncryptionArgs> {
        return this.showConfigDialog(boardWebUser, "Enable encryption", "New password", "Confirm password", (firstPassword: string, secondPassword: string) => {
            return { valid: firstPassword === secondPassword, errorMessage: "Password does not match the confirm password." };
        });
    }

    showRemovePasswordDialog(boardWebUser: User): any {
        return this.showConfigDialog(boardWebUser, "Disable encryption", "Password", "", (firstPassword: string, secondPassword: string) => {
            return { valid: true, errorMessage: "" };
        });
    }

    showChangePasswordDialog(boardWebUser: User): any {
        return this.showConfigDialog(boardWebUser, "Change password", "Old Password", "New Password", (firstPassword: string, secondPassword: string) => {
            return { valid: true, errorMessage: "" };
        });
    }

    private showConfigDialog(boardWebUser: User, title: string, firstPasswordKey: string, secondPasswordKey: string, validation: (firstPassword: string, secondPassword: string) => { valid: boolean, errorMessage: string }): ng.IPromise<IBEngLogEncryptionArgs> {

        if (angular.isUndefined(boardWebUser)) {
            return this.$q.reject();
        }

        return this.$mdDialog.show({
            controller: BengLogPasswordDialogController,
            controllerAs: "$ctrl",
            template: require("./beng-log-password-dialog.html"),
            focusOnOpen: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            bindToController: true,
            fullscreen: true,
            multiple: true,
            locals: {
                "title": title,
                "boardWebUser": boardWebUser,
                "firstPasswordKey": firstPasswordKey,
                "secondPasswordKey": secondPasswordKey,
                "validation": validation
            }
        });

    }
}

export class BengLogPasswordDialogController {

    private title: string;

    private boardWebUser: User;

    private firstPasswordKey: string;
    private secondPasswordKey: string;

    private firstPassword: string;
    private secondPassword: string;

    private firstPasswordEnabled: boolean;
    private secondPasswordEnabled: boolean;
    private applyDisabled: boolean;

    private validation: (firstPassword: string, secondPassword: string) => { valid: boolean, errorMessage: string };

    static $inject = ["$mdDialog"];
    constructor(private $mdDialog: ng.material.IDialogService) {
        this.firstPasswordEnabled = this.firstPasswordKey !== undefined && this.firstPasswordKey.length > 0;
        this.secondPasswordEnabled = this.secondPasswordKey !== undefined && this.secondPasswordKey.length > 0;
        this.applyDisabled = true;
    }

    private valueChanged() {
        const firstPasswordHasInvalidValue = this.firstPasswordEnabled && (this.firstPassword === undefined || this.firstPassword.length === 0);
        const secondPasswordHasValidValue = this.secondPasswordEnabled && (this.secondPassword === undefined || this.secondPassword.length === 0);
        this.applyDisabled = firstPasswordHasInvalidValue || secondPasswordHasValidValue;
    }

    private applyChanges() {

        const result = this.validation(this.firstPassword, this.secondPassword);
        if (!result.valid) {
            return this.$mdDialog.cancel(result.errorMessage);
        }

        const args: IBEngLogEncryptionArgs = {
            firstPassword: this.firstPassword,
            secondPassword: this.secondPassword
        };

        return this.$mdDialog.hide(args);
    }

    private cancel() {
        this.$mdDialog.cancel("");
    }

}


// WEBPACK FOOTER //
// ./app/beng-logs/beng-log-password-dialog.controller.ts